import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CustomButton from "../CustomButton";
import CandleImg from "../../assets/images/virtual-candle-img.jpg";
import { TbCandle } from "react-icons/tb";
import "./VirtualCandleCall.css";

export default function VirtualCandleCall(props) {
  return (
    <Container className="virtual-candle-section">
      <Row>
        <Col className="virtual-candle-first-col">
          <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
            <TbCandle
              style={{ color: props.iconColor }}
              className="virtual-candle-icon"
            />
            VELA VIRTUAL
          </h2>
        </Col>
      </Row>
      <Row>
        <Col lg={6} className="virtual-candle-third-col">
          <p style={{ color: props.textColor, fontSize: props.textSize }}>
            Veja as Velas Virtuais em memória daqueles que permanecem vivos em
            nossas lembranças.
          </p>
          <CustomButton
            className="primary-btn"
            variant="primary"
            href="/velas-virtuais/"
            icon=""
            content="VER VELAS"
            backgroundColor={props.primaryBtnColor}
            fontFamily="Unageo-Bold"
            fontColor={props.white}
            fontSize={20}
            width={240}
            borderColor={props.primaryBtnColor}
            disabled={false}
          />
        </Col>
        <Col
          lg={{ span: 6, order: "first" }}
          className="virtual-candle-second-col"
        >
          <div className="virtual-candle-img-container">
            <img src={CandleImg} alt="velas" />
            <div className="virtual-candle-img-overlay" />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
